module.exports = __webpack_public_path__ + "img/flag-southafrica-big.e69f05d4.png";